import { takeLatest, call, put, select } from "redux-saga/effects";
import { FETCH_DATA_REQUEST, FILE_DOWNLOAD_REQUEST } from "./constants";
import { fetchNetworkApi, fetchApi } from "@mochi/core";
import { makeLambdaRequest } from "@mochi/misc/fetch-api";
import { fetchHomeScreenSuccess, fetchFileDownLoadSuccess } from "./actions";
import * as Helpers from '../../../utils/helpers'
import * as Api from '../../../services';
const { NODE_ENV, REACT_APP_PROD_DOMAIN_URI } = process.env;


function* createAnonymousToken(action) {
  const { params } = action.payload
  const request = yield makeLambdaRequest('GET_TOKEN_HOME_SCREEN', params);
  const actions = yield fetchApi(request);
  const res = yield call(fetchNetworkApi, actions);
  return res
}


function* getFileGuide(action) {
  const infoAnonymousToken: any = localStorage.getItem('infoAnonymousToken');
  const anonymous = JSON.parse(infoAnonymousToken);
  const { anonymousToken, expireDateTime, uuid, bookingSiteUrl } = anonymous;
  const state = yield select();

  if (state.homeScreen.file === '') {
    const responds = yield Api.getDataFileDownload({ anonymousToken, expireDateTime, uuid, bookingSiteUrl });
    const { data } = responds.data;
    if (data === undefined) {
      const history = action.payload;
      history.push('/download-error');
      return
    }
    Helpers.handleFilePdf(data);
    yield put(fetchFileDownLoadSuccess(data));
  } else {
    Helpers.handleFilePdf(state.homeScreen.file);
  }
}

function* getDataHomeScreen(anonymousToken, expireDateTime, uuid, bookingSiteUrl) {
  const responds = yield Api.getDataHomeScreen({ anonymousToken, expireDateTime, uuid, bookingSiteUrl });
  const { data } = responds.data;
  localStorage.setItem('_data', JSON.stringify(data || {}));
  yield put(fetchHomeScreenSuccess({ data }));

  const infoAnonymousToken = JSON.stringify({ anonymousToken, expireDateTime, uuid, bookingSiteUrl })
  localStorage.setItem('infoAnonymousToken', infoAnonymousToken)
}

function* fetchToken(payload) {
  const { pathname } = payload.payload;
  const bookingSiteUrl = NODE_ENV === 'development' ? `${REACT_APP_PROD_DOMAIN_URI}${pathname}` : window.location.href;
  const { getUUID: uuid } = payload.payload;
  const res = yield createAnonymousToken(payload)

  if (res.payload && res.payload.status === 2) {
    const { anonymousToken, expireDateTime } = res.payload.httpResponseJson;
    localStorage.setItem('_data', JSON.stringify(bookingSiteUrl || {}));

    // yield getFileGuide(anonymousToken, expireDateTime, uuid, bookingSiteUrl);
    yield getDataHomeScreen(anonymousToken, expireDateTime, uuid, bookingSiteUrl)
  }
}

export function* saga() {
  yield takeLatest(FETCH_DATA_REQUEST, fetchToken);
  yield takeLatest(FILE_DOWNLOAD_REQUEST, getFileGuide);
}
